/**
 * @generated SignedSource<<513c0a1e9198ebaa67298dca144d9af0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NotificationCategory = "UPGRADE" | "SUPPORT" | "INCIDENT" | "EVENT" | "OTHER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NotificationTableDataRow_notification$data = {
  readonly id: string;
  readonly slug: string;
  readonly title: string;
  readonly publishedAt: string;
  readonly category: NotificationCategory | null;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationColumn_notification">;
  readonly " $fragmentType": "NotificationTableDataRow_notification";
};
export type NotificationTableDataRow_notification = NotificationTableDataRow_notification$data;
export type NotificationTableDataRow_notification$key = {
  readonly " $data"?: NotificationTableDataRow_notification$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationTableDataRow_notification">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationTableDataRow_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationColumn_notification"
    }
  ],
  "type": "Notification",
  "abstractKey": null
};

(node as any).hash = "65f3ad819a231a82d545d0511f4780ae";

export default node;
